import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Waypoint from 'react-waypoint';
import ismobilejs from 'ismobilejs';

import './Story2.css';

class Story2 extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  state = {
    title: false,
    image: false,
    mobileImage: false
  };

  render() {
    return (
      <div className={classnames('Story2', this.props.className, {
        'Story2--appear': this.state.image
      })}>
        <div className="Story2__content">
          <Waypoint
            onPositionChange={this._onPositionChange.bind(this, 'title')}
            bottomOffset="-300px"
          />
          <h2 className={classnames('Story2__title', {
            'Story2__title--appear': this.state.title
          })}>
            <FormattedMessage id="Story2.title"/>
          </h2>
          <Waypoint
            onPositionChange={this._onPositionChange.bind(this, 'image')}
            bottomOffset="300px"
          />
          {
             ismobilejs.any &&
             <Waypoint
               onPositionChange={this._onPositionChange.bind(this, 'mobileImage')}
               bottomOffset="300px"
             />
          }
          <div className="Story2__block"/>
        </div>
      </div>
    );
  }

  _onPositionChange = (key, { currentPosition }) => {
    if (currentPosition === 'above' || currentPosition === 'inside') {
      this.setState({
        [key]: true
      });
    } else if (currentPosition === 'below') {
      this.setState({
        [key]: false
      });
    }
  };

}

export default Story2;



// WEBPACK FOOTER //
// ./src/components/Story2.js